import type { MessageKey } from 'types/LocaleMessageKey';

interface HighlightedFeatureData {
  id: number;
  text: MessageKey;
  image: {
    src: string;
    alt: MessageKey;
  };
}

export const membershipHighlightedFeaturesData: HighlightedFeatureData[] = [
  {
    id: 1,
    text: 'membership_features_highlight_sleep_analysis',
    image: {
      src: 'membership/feature-highlight-01-img2x',
      alt: 'membership_feature_highlight_1_alt',
    },
  },
  {
    id: 2,
    text: 'membership_features_highlight_health_insights',
    image: {
      src: 'membership/feature-highlight-02-img2x',
      alt: 'membership_feature_highlight_2_alt',
    },
  },
  {
    id: 3,
    text: 'membership_features_highlight_heart_rate_monitoring',
    image: {
      src: '/membership/feature-highlight-03-img2x',
      alt: 'membership_feature_highlight_3_alt',
    },
  },
  {
    id: 4,
    text: 'membership_features_highlight_body_temp',
    image: {
      src: 'membership/feature-highlight-04-img2x',
      alt: 'membership_feature_highlight_4_alt',
    },
  },
];
